import { configure } from "mobx";

// Gradifi shares pages with independently bundled applications. Keep this
// bundle's MobX state private so another MobX version cannot claim or reject it.
configure({ isolateGlobalState: true });
